import React from "react";

import { PanelRightOpen, PanelRightClose } from "lucide-react";

import ToolbarIconButton from "../TemplatePanel/ToolbarIconButton";
import { toggleInspectorDrawerOpen, useInspectorDrawerOpen } from "../../documents/editor/EditorContext";

export default function ToggleInspectorPanelButton() {
  const inspectorDrawerOpen = useInspectorDrawerOpen();
  const Icon = inspectorDrawerOpen ? PanelRightClose : PanelRightOpen;

  return (
    <ToolbarIconButton
      tooltip={inspectorDrawerOpen ? "Hide styles panel" : "Show styles panel"}
      icon={<Icon className="size-4" />}
      onClick={toggleInspectorDrawerOpen}
    />
  );
}
